import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Box, Typography, Button, IconButton, Checkbox } from "@mui/material";
import SoftBox from "components/SoftBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import moment from "moment";
import { getImageUrl } from "api/AttachmentAPI";
// import { fontSize } from "@mui/system";
// import ImageCustom from "components/ImageCustom/ImageCustom";

function DesignItem({ item, checked, onCheck, onEdit, onDelete, onOrder }) {
  const [imageUrl, setImageUrl] = useState(null);

  useEffect(() => {
    const fetchImage = async () => {
      const result = await getImageUrl(`/api/attachments/downloadFile/${item.encryptedId}`);
      if (typeof result === "string") {
        setImageUrl(result);
      } else {
        // eslint-disable-next-line no-console
        console.error("Lỗi khi tải ảnh", result?.message || result);
      }
    };

    if (item.encryptedId) {
      fetchImage();
    }
  }, [item.encryptedId]);

  const navigate = useNavigate();

  const handleEdit = (designItem) => {
    if (!designItem.isWeb) {
      Swal.fire({
        icon: "warning",
        title: "Không thể chỉnh sửa",
        text: "Thiết kế này được tạo từ điện thoại và không thể chỉnh sửa trên web.",
        confirmButtonText: "Ok",
      });
      return;
    }

    navigate("/", { state: { designToEdit: designItem } });
  };

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        background: "rgba(255, 255, 255, 0.9)",
        backdropFilter: "blur(6px)",
        boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
        transition: "all 0.3s ease",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        alignItems: { sm: "center" },
        gap: 2,
        maxWidth: "100%",
      }}
    >
      {/* Ảnh và checkbox */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
          width: "fit-content",
          maxWidth: { xs: "100%", sm: 420 },
          flexShrink: 0,
        }}
      >
        <Checkbox
          key={item.id}
          checked={checked}
          onChange={onCheck}
          sx={{
            "& .MuiSvgIcon-root": {
              fill: "#0094FF !important",
            },
          }}
        />
        {imageUrl ? (
          <Box
            sx={{
              width: { xs: "100%", sm: 400 },
              height: 300,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "#f9f9f9",
              borderRadius: 2,
              overflow: "hidden",
            }}
          >
            <Box
              component="img"
              src={imageUrl}
              alt={item.templateName}
              sx={{
                maxHeight: "100%",
                maxWidth: "100%",
                objectFit: "contain",
              }}
            />
          </Box>
        ) : (
          <Typography variant="body2">Đang tải ảnh...</Typography>
        )}
      </Box>

      {/* Thông tin */}
      <Box flex={1} minWidth={0} sx={{ pl: { sm: 4 } }}>
        <Typography sx={{ mb: 1 }}>
          <Box component="span" fontWeight="bold">
            Sản phẩm:
          </Box>{" "}
          {item.templateName}
        </Typography>
        <Typography sx={{ mb: 1 }}>
          <Box component="span" fontWeight="bold">
            Ngày cập nhật:
          </Box>{" "}
          {moment(item.updatedAt).format("DD/MM/YYYY")}
        </Typography>

        {item?.requestId ? (
          <>
            <Box component="span" fontWeight="bold">
              Trạng thái đặt hàng:
            </Box>{" "}
            <SoftBox
              sx={{
                backgroundColor:
                  item?.requestStatus === 0
                    ? "#F59F00"
                    : item?.requestStatus === 1
                    ? "#54B7FF"
                    : "#37B24D",
                color: "#fff",
                fontWeight: "bold",
                borderRadius: "8px",
                px: 2,
                py: 0.5,
                display: "inline-block",
                fontSize: 14,
                mt: 1,
                mb: 2,
              }}
            >
              {item?.requestStatus === 0
                ? "Chờ xác nhận"
                : item?.requestStatus === 1
                ? "Đã liên hệ"
                : "Đã báo giá"}
            </SoftBox>
            <Button variant="contained" size="small" disabled>
              Đã gửi liên hệ
            </Button>
          </>
        ) : (
          <>
            <Box sx={{ display: "flex", gap: 1, alignItems: "center", mb: 1 }}>
              <IconButton color="primary" onClick={() => onEdit(item.id)}>
                <EditIcon fontSize="small" />
              </IconButton>
              <Typography
                variant="body2"
                sx={{ cursor: "pointer" }}
                onClick={() => handleEdit(item)}
              >
                Chỉnh sửa
              </Typography>
              <IconButton color="error" onClick={() => onDelete(item.id)}>
                <DeleteIcon fontSize="small" />
              </IconButton>
              <Typography variant="body2">Xoá</Typography>
            </Box>
            <Button variant="contained" size="small" onClick={() => onOrder(item)}>
              Liên hệ tư vấn / báo giá
            </Button>
          </>
        )}
      </Box>
    </Box>
  );
}

DesignItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    frontImage: PropTypes.string.isRequired,
    backImage: PropTypes.string.isRequired,
    templateName: PropTypes.string.isRequired,
    updatedAt: PropTypes.string.isRequired,
    encryptedId: PropTypes.string.isRequired,
    requestId: PropTypes.number.isRequired,
    requestStatus: PropTypes.number.isRequired,
  }).isRequired,
  checked: PropTypes.bool.isRequired,
  onCheck: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onOrder: PropTypes.func.isRequired,
};

export default DesignItem;
